var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLogined)?_c('router-view'):_c('div',{staticClass:"oasis-login-tips"},[_c('p',[_vm._v("用户没有登录,请先登录")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }